import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import da from './da.json';
import en from './en.json';

const savedLang = localStorage.getItem('rfo_language') ?? 'da';

i18n.use(initReactI18next).init({
  resources: { da: { translation: da }, en: { translation: en } },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
